import { observer } from "mobx-react"

const FutureGoals = observer(() => {
    return (<>
        <div className="bg-light py-3">
            <section className="frosty-visions">
                <h2 className="arctic-title">Future Goals and Developments</h2>
                <ul className="polar-aspirations">
                <img src="assets/img/right12.png" className="header-img-coin3" />
                <img src="assets/img/stack.png" className="header-img-coin6" />


                    <li className="icicle-point">
                        <strong>Governance:</strong> SnowballBoss will eventually introduce
                        decentralized governance, allowing the community to vote on decisions
                        such as Community Allocations and project developments.
                    </li>
                    <li className="icicle-point">
                        <strong>Cross-Chain Expansion:</strong> Plans to expand SnowballBoss
                        to other blockchains like Ethereum, Polygon, and others to increase
                        accessibility and adoption.
                    </li>
                    <li className="icicle-point">
                        <strong>Creative Collaborations:</strong> SnowballBoss will
                        collaborate with meme influencers, content creators, and popular
                        culture figures to continue its viral growth.
                    </li>
                </ul>
            </section>
        </div>
    </>)
});

export default FutureGoals;